import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitDiagnostic = async (payload) => {
  const { data } = await axios.post(`${API}/diagnostic`, payload);
  return data;
};

export const getDiagnosticQuestions = async () => {
  const { data } = await axios.get(`${API}/diagnostic/questions`);
  return data;
};

export const submitContact = async (payload) => {
  const { data } = await axios.post(`${API}/contact`, payload);
  return data;
};

export const submitReview = async (payload) => {
  const { data } = await axios.post(`${API}/reviews`, payload);
  return data;
};

export const getReviews = async () => {
  const { data } = await axios.get(`${API}/reviews`);
  return data;
};
